<template>
    <div>
        <div class="datanull" v-if="flag">
            暂无相关数据！
        </div>
        <div v-for="(item,index) in pictureList" :key="index" class="boxContent" @click="enterDetails(item)">
            <div class="oneImg" v-if="item.thumb">
                <div class="newsThumbOne">
                    <img class="newsThumb" :src="item.thumb.split(',')[0]" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:["dataLink"],
    data(){
        return{
            flag: false,    // 控制暂无数据这个div的显示与隐藏
            pictureList:[], //图片列表
            mescroll:null, // mescroll实例对象
            mescrollUp: {
                callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
                page: {
                    num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
                    size: 10 // 每页数据的数量
                },
                htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
                noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                toTop: {
                    src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
                },
                auto:false,
                lazyLoad: {
                    use: false // 是否开启懒加载,默认false
                }
            }
        }
    },
    created() {
      // 获取所有的图片列表
      this.getPictureList()
    },
    methods:{
        getPictureList(){
			this.$http.get(this.dataLink)
            .then(resp=>{
                if(resp.data.status=='ok'){
                  this.pictureList=resp.data.newxmlbList;
                  if (!resp.data) {
                      this.flag = true
                  }
                }
            });
        },
        // 上拉加载，下拉刷新
        // mescroll组件初始化的回调,可获取到mescroll对象
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
        upCallback (page, mescroll) {
            var pageNum = page.num; // 页码, 默认从1开始 如何修改从0开始 ?
            this.$http.get(this.dataLink + '&pageid='+pageNum) //调接口
            .then(resp=>{
                if(resp.data.status=='ok'){
                    if (page.num === 1) {
                      this.pictureList = [];
                    }
                    if(resp.data.newslist){
                        this.pictureList=this.pictureList.concat(resp.data.newxmlbList);
                    }
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
                this.$nextTick(()=>{
                    if(resp.data.newslist){
                        mescroll.endSuccess(resp.data.newxmlbList.length);
                    }else{
                        mescroll.endSuccess(0);
                    }
                })
            }).catch(()=>{
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                mescroll.endErr()
            });
        },
        enterDetails(item){
            var link;
            link=item.linkurl; //外部链接
            // window.location.href=link;
            this.linkPhone({url: link,title:item.title,noRefresh:"noRefresh"});
        }
    }
}
</script>

<style  scoped>
    .datanull{
        width: 100%;
        height: 100%;
        color: #999999;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
    }
    .boxContent{
        /* width: calc(100% - 24px); */
        width: 100%;
        padding: 0 15px;
        margin: 10px auto;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    .oneImg{
        width:100%;
        /* height:80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .newsThumbBox{
        width: 100%;
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .newsThumbBoxOne{
        height: 185px;
        position: relative;
    }
    .newsThumbBox>div{
        width: 32%;
        height: 100%;
    }
    .newsThumbOne{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .newsThumb{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }
</style>